export const LANGS = [
  { code: "fr", label: "FR", name: "Français" },
  { code: "en", label: "EN", name: "English" },
  { code: "ru", label: "RU", name: "Русский" },
  { code: "uk", label: "UK", name: "Українська" },
];

export const BRAND = {
  name: "A&K Atelier",
  sub: "Artisan Créateur de Décors en Plâtre",
};

export const translations = {
  fr: {
    brand: "A&K Atelier",
    nav: { home: "Accueil", about: "Atelier", services: "Services", products: "Catalogue", portfolio: "Réalisations", contact: "Contact" },
    hero: {
      badge: "Artisan créateur de décors en plâtre",
      title: "L'art du plâtre, sublimé",
      subtitle:
        "Corniches, rosaces, colonnes et décors sur mesure. Nous transformons chaque espace avec élégance, savoir-faire traditionnel et design contemporain.",
      cta1: "Demander un devis",
      cta2: "Voir nos réalisations",
    },
    about: {
      badge: "Notre atelier",
      title: "Le savoir-faire au service de la noblesse",
      founded: "Atelier fondé en 2006",
      p1: "A&K Atelier allie le savoir-faire traditionnel au design contemporain. Nous créons des pièces en plâtre naturel qui apportent élégance, personnalité et noblesse à chaque espace.",
      p2: "Des statuettes classiques aux panneaux décoratifs modernes, nous offrons des possibilités illimitées pour l'aménagement intérieur — sur mesure, du premier croquis à la pose.",
      stats: { projects: "Projets réalisés", clients: "Clients satisfaits", experience: "Années d'expérience", custom: "Sur mesure" },
    },
    services: {
      badge: "Ce que nous créons",
      title: "Nos services",
      subtitle: "Une gamme complète de décors en plâtre naturel, façonnés à la main.",
      items: {
        corniches: { title: "Corniches", desc: "Corniches lisses et ornées qui habillent vos plafonds avec finesse." },
        rosaces: { title: "Rosaces", desc: "Rosaces de plafond classiques et modernes, point d'orgue de la pièce." },
        colonnes: { title: "Colonnes & Pilastres", desc: "Colonnes et pilastres qui structurent l'espace avec majesté." },
        moulures: { title: "Moulures & Frises", desc: "Moulures, frises et baguettes pour des transitions élégantes." },
        panneaux: { title: "Panneaux décoratifs", desc: "Panneaux et cadres muraux qui transforment chaque surface." },
        decor: { title: "Décor sur mesure", desc: "Créations uniques en plâtre, conçues selon votre projet." },
        restauration: { title: "Restauration", desc: "Restauration d'éléments de façade et de moulures anciennes en plâtre, intérieures comme extérieures." },
      },
    },
    process: {
      badge: "Notre méthode",
      title: "Comment nous travaillons",
      steps: {
        a: { title: "Consultation & devis", desc: "Nous échangeons sur votre projet et établissons un devis gratuit." },
        b: { title: "Conception & croquis", desc: "Nous dessinons les croquis et sélectionnons les profils adaptés." },
        c: { title: "Fabrication artisanale", desc: "Chaque pièce est moulée et finie à la main en plâtre naturel." },
        d: { title: "Pose & finition", desc: "Installation soignée et finitions impeccables sur site." },
      },
    },
    portfolio: {
      badge: "Nos réalisations",
      title: "Galerie de nos travaux",
      subtitle: "Découvrez nos projets réels — photographies et vidéos de nos chantiers.",
      photos: "Photos",
      videos: "Vidéos",
      view: "Agrandir",
      share: "Partager",
      shareCopy: "Copier le lien",
      shareCopied: "Lien copié !",
      cats: { all: "Tous", corniches: "Corniches", moulures: "Moulures", colonnes: "Colonnes", interieurs: "Intérieurs" },
    },
    why: {
      badge: "Pourquoi nous choisir",
      title: "La différence A&K Atelier",
      items: {
        a: { title: "Plâtre naturel", desc: "Des matériaux nobles et sains pour des finitions durables." },
        b: { title: "Fait main", desc: "Chaque pièce est façonnée et finie à la main par nos artisans." },
        c: { title: "Sur mesure", desc: "Du croquis à la pose, nous adaptons chaque détail à votre espace." },
        d: { title: "Finition impeccable", desc: "Une attention méticuleuse portée au moindre détail." },
      },
    },
    testimonials: {
      badge: "Ils nous font confiance",
      title: "Avis de nos clients",
      items: {
        a: { name: "Sophie L.", role: "Architecte d'intérieur", text: "Un travail d'une finesse exceptionnelle. Les corniches subliment chaque pièce." },
        b: { name: "Marc D.", role: "Propriétaire", text: "Atelier sérieux et passionné. Pose impeccable, résultat à la hauteur." },
        c: { name: "Élodie R.", role: "Décoratrice", text: "Des rosaces magnifiques, entièrement faites main. Je recommande vivement." },
      },
    },
    catalog: {
      badge: "Notre catalogue",
      title: "Produits & solutions",
      subtitle: "Une gamme complète d'éléments décoratifs en plâtre, à découvrir par catégorie.",
      all: "Tous",
      search: "Rechercher un produit…",
      quote: "Demander un devis",
      empty: "Aucun produit dans cette catégorie pour le moment.",
      more: "Voir plus",
      sort: "Trier",
      sortDefault: "Recommandé",
      sortAz: "Nom A→Z",
      sortZa: "Nom Z→A",
      order: "Commander sur WhatsApp",
      details: "Fiche produit",
      similar: "Vous aimerez aussi",
      badges: { hit: "Best-seller", new: "Nouveau" },
      bestBadge: "Sélection",
      bestTitle: "Nos best-sellers",
      bestSubtitle: "Les pièces les plus demandées par nos clients.",
      cats: {
        corniches: "Corniches", rosaces: "Rosaces & boîtes", moldings: "Moulures & ornements",
        wallpaper: "Papiers peints", skirtings: "Plinthes", cladding: "Revêtement mural",
        panels3d: "Panneaux 3D", lighting: "Éclairage", technical: "Solutions techniques",
        colonnes: "Colonnes & agencement",
      },
    },
    favorites: {
      title: "Favoris",
      add: "Ajouter aux favoris",
      remove: "Retirer des favoris",
      added: "Ajouté aux favoris",
      removed: "Retiré des favoris",
      empty: "Votre liste de favoris est vide. Ajoutez des pièces avec le cœur ♥.",
      clear: "Vider la liste",
      sendWa: "Envoyer la liste sur WhatsApp",
      waIntro: "Bonjour, voici les pièces qui m'intéressent :",
      qty: "Qté",
      unit: "pce(s)",
      size: "dimensions",
      sizePlaceholder: "Dimensions / notes (ex. L 2,5 m)",
    },
    cookie: {
      text: "Nous utilisons des cookies pour améliorer votre expérience et mesurer notre audience.",
      accept: "Accepter", decline: "Refuser", learn: "En savoir plus",
    },
    legal: { privacyTitle: "Politique de confidentialité", legalTitle: "Mentions légales", back: "Retour au site", updated: "Dernière mise à jour" },
    reviews: {
      badge: "Avis clients",
      title: "Ils ont fait appel à nous",
      subtitle: "Découvrez les avis de nos clients et partagez votre expérience.",
      leave: "Laisser un avis",
      empty: "Soyez le premier à laisser un avis.",
      form: {
        title: "Partager votre avis",
        rating: "Votre note",
        text: "Votre avis",
        textPlaceholder: "Décrivez votre expérience avec A&K Atelier…",
        photos: "Photos (jusqu'à 5)",
        add: "Ajouter des photos",
        submit: "Publier l'avis",
        sending: "Publication…",
        success: "Merci ! Votre avis a été publié.",
        error: "Erreur lors de la publication. Réessayez.",
        loginRequired: "Connectez-vous pour laisser un avis.",
      },
    },
    auth: {
      signin: "Se connecter",
      account: "Mon compte",
      logout: "Se déconnecter",
      loginTitle: "Connexion",
      registerTitle: "Créer un compte",
      name: "Nom",
      email: "E-mail",
      password: "Mot de passe",
      doLogin: "Se connecter",
      doRegister: "S'inscrire",
      google: "Continuer avec Google",
      or: "ou",
      haveAccount: "Déjà un compte ? Se connecter",
      noAccount: "Pas de compte ? S'inscrire",
      welcome: "Bonjour",
    },
    faq: {
      badge: "Questions fréquentes",
      title: "Vous vous demandez…",
      items: {
        a: { q: "Travaillez-vous sur mesure ?", a: "Oui, chaque décor est conçu et fabriqué selon votre projet et vos dimensions." },
        b: { q: "Quels matériaux utilisez-vous ?", a: "Du plâtre naturel de haute qualité, sain, durable et écologique." },
        c: { q: "Intervenez-vous en rénovation ?", a: "Oui, en neuf comme en rénovation, en intérieur comme en façade." },
        d: { q: "Quels sont les délais ?", a: "Cela dépend du projet ; nous précisons les délais avec le devis gratuit." },
      },
    },
    contact: {
      badge: "Parlons de votre projet",
      title: "Demander un devis",
      subtitle: "Laissez-nous vos coordonnées, nous vous recontactons rapidement.",
      name: "Votre nom",
      phone: "Téléphone",
      email: "E-mail",
      message: "Décrivez votre projet",
      submit: "Envoyer la demande",
      sending: "Envoi…",
      success: "Merci ! Votre demande a bien été envoyée.",
      error: "Une erreur est survenue. Réessayez ou contactez-nous via WhatsApp.",
      whatsapp: "Écrire sur WhatsApp",
      infoTitle: "Coordonnées",
      hoursLabel: "Horaires",
      hoursValue: "Lun – Ven : 9h00 – 18h00",
      weekend: "Samedi & Dimanche : fermé",
    },
    footer: { tagline: "L'art du plâtre décoratif — corniches, rosaces, colonnes et décors sur mesure.", rights: "Tous droits réservés.", nav: "Navigation", contact: "Contact", privacy: "Confidentialité", legal: "Mentions légales" },
  },

  en: {
    brand: "A&K Atelier",
    nav: { home: "Home", about: "Atelier", services: "Services", products: "Catalog", portfolio: "Portfolio", contact: "Contact" },
    hero: {
      badge: "Artisan creator of plaster decor",
      title: "The art of plaster, perfected",
      subtitle:
        "Cornices, rosettes, columns and bespoke decor. We transform every space with elegance, traditional craftsmanship and contemporary design.",
      cta1: "Request a quote",
      cta2: "See our work",
    },
    about: {
      badge: "Our atelier",
      title: "Craftsmanship in the service of elegance",
      founded: "Atelier founded in 2006",
      p1: "A&K Atelier blends traditional craftsmanship with contemporary design. We create natural plaster pieces that bring elegance, personality and nobility to every space.",
      p2: "From classic statuettes to modern decorative panels, we offer limitless possibilities for interior design — bespoke, from the first sketch to installation.",
      stats: { projects: "Completed projects", clients: "Happy clients", experience: "Years of experience", custom: "Bespoke" },
    },
    services: {
      badge: "What we create",
      title: "Our services",
      subtitle: "A complete range of natural plaster decor, shaped by hand.",
      items: {
        corniches: { title: "Cornices", desc: "Smooth and ornate cornices that dress your ceilings with finesse." },
        rosaces: { title: "Ceiling Rosettes", desc: "Classic and modern ceiling rosettes — the highlight of any room." },
        colonnes: { title: "Columns & Pilasters", desc: "Columns and pilasters that structure space with majesty." },
        moulures: { title: "Moldings & Friezes", desc: "Moldings, friezes and trims for elegant transitions." },
        panneaux: { title: "Decorative Panels", desc: "Wall panels and frames that transform every surface." },
        decor: { title: "Bespoke Decor", desc: "Unique plaster creations designed around your project." },
        restauration: { title: "Restoration", desc: "Restoration of façade elements and old plaster moldings, both interior and exterior." },
      },
    },
    process: {
      badge: "Our method",
      title: "How we work",
      steps: {
        a: { title: "Consultation & quote", desc: "We discuss your project and prepare a free quote." },
        b: { title: "Design & sketches", desc: "We draw sketches and select the right profiles." },
        c: { title: "Handcrafted making", desc: "Every piece is moulded and finished by hand in natural plaster." },
        d: { title: "Installation & finish", desc: "Careful on-site installation and flawless finishing." },
      },
    },
    portfolio: {
      badge: "Our work",
      title: "Gallery of our projects",
      subtitle: "Explore our real projects — photographs and videos from our sites.",
      photos: "Photos",
      videos: "Videos",
      view: "Enlarge",
      share: "Share",
      shareCopy: "Copy link",
      shareCopied: "Link copied!",
      cats: { all: "All", corniches: "Cornices", moulures: "Moldings", colonnes: "Columns", interieurs: "Interiors" },
    },
    why: {
      badge: "Why choose us",
      title: "The A&K Atelier difference",
      items: {
        a: { title: "Natural Plaster", desc: "Noble, healthy materials for long-lasting finishes." },
        b: { title: "Handmade", desc: "Every piece is shaped and finished by hand by our artisans." },
        c: { title: "Bespoke", desc: "From sketch to installation, we tailor every detail to your space." },
        d: { title: "Flawless Finish", desc: "Meticulous attention to the smallest detail." },
      },
    },
    testimonials: {
      badge: "They trust us",
      title: "What our clients say",
      items: {
        a: { name: "Sophie L.", role: "Interior Architect", text: "Work of exceptional finesse. The cornices elevate every room." },
        b: { name: "Marc D.", role: "Homeowner", text: "A serious and passionate atelier. Flawless installation, results to match." },
        c: { name: "Élodie R.", role: "Decorator", text: "Magnificent rosettes, entirely handmade. Highly recommended." },
      },
    },
    catalog: {
      badge: "Our catalogue",
      title: "Products & solutions",
      subtitle: "A complete range of decorative plaster elements — explore by category.",
      all: "All",
      search: "Search a product…",
      quote: "Request a quote",
      empty: "No products in this category yet.",
      more: "Load more",
      sort: "Sort",
      sortDefault: "Recommended",
      sortAz: "Name A→Z",
      sortZa: "Name Z→A",
      order: "Order on WhatsApp",
      details: "Product details",
      similar: "You may also like",
      badges: { hit: "Best-seller", new: "New" },
      bestBadge: "Selection",
      bestTitle: "Our best-sellers",
      bestSubtitle: "The pieces most requested by our clients.",
      cats: {
        corniches: "Cornices", rosaces: "Rosettes & boxes", moldings: "Moldings & ornaments",
        wallpaper: "Wallpapers", skirtings: "Skirtings", cladding: "Wall cladding",
        panels3d: "3D panels", lighting: "Lighting", technical: "Technical solutions",
        colonnes: "Columns & fittings",
      },
    },
    favorites: {
      title: "Favourites",
      add: "Add to favourites",
      remove: "Remove from favourites",
      added: "Added to favourites",
      removed: "Removed from favourites",
      empty: "Your favourites list is empty. Add pieces with the heart ♥.",
      clear: "Clear list",
      sendWa: "Send list on WhatsApp",
      waIntro: "Hello, here are the pieces I'm interested in:",
      qty: "Qty",
      unit: "pc(s)",
      size: "dimensions",
      sizePlaceholder: "Dimensions / notes (e.g. L 2.5 m)",
    },
    cookie: {
      text: "We use cookies to improve your experience and measure our audience.",
      accept: "Accept", decline: "Decline", learn: "Learn more",
    },
    legal: { privacyTitle: "Privacy Policy", legalTitle: "Legal Notice", back: "Back to site", updated: "Last updated" },
    reviews: {
      badge: "Client reviews",
      title: "They trusted us",
      subtitle: "Read our clients' reviews and share your own experience.",
      leave: "Leave a review",
      empty: "Be the first to leave a review.",
      form: {
        title: "Share your review",
        rating: "Your rating",
        text: "Your review",
        textPlaceholder: "Describe your experience with A&K Atelier…",
        photos: "Photos (up to 5)",
        add: "Add photos",
        submit: "Publish review",
        sending: "Publishing…",
        success: "Thank you! Your review has been published.",
        error: "Failed to publish. Please try again.",
        loginRequired: "Sign in to leave a review.",
      },
    },
    auth: {
      signin: "Sign in",
      account: "My account",
      logout: "Sign out",
      loginTitle: "Sign in",
      registerTitle: "Create account",
      name: "Name",
      email: "E-mail",
      password: "Password",
      doLogin: "Sign in",
      doRegister: "Sign up",
      google: "Continue with Google",
      or: "or",
      haveAccount: "Already have an account? Sign in",
      noAccount: "No account? Sign up",
      welcome: "Hello",
    },
    faq: {
      badge: "Frequently asked",
      title: "You may be wondering…",
      items: {
        a: { q: "Do you work to measure?", a: "Yes, every decor is designed and made to your project and dimensions." },
        b: { q: "What materials do you use?", a: "High-quality natural plaster — healthy, durable and eco-friendly." },
        c: { q: "Do you work on renovations?", a: "Yes, for new builds and renovations, both interior and façade." },
        d: { q: "What are the lead times?", a: "It depends on the project; we confirm timelines with the free quote." },
      },
    },
    contact: {
      badge: "Let's talk about your project",
      title: "Request a quote",
      subtitle: "Leave your details and we'll get back to you quickly.",
      name: "Your name",
      phone: "Phone",
      email: "E-mail",
      message: "Describe your project",
      submit: "Send request",
      sending: "Sending…",
      success: "Thank you! Your request has been sent.",
      error: "Something went wrong. Try again or reach us on WhatsApp.",
      whatsapp: "Message on WhatsApp",
      infoTitle: "Contact details",
      hoursLabel: "Hours",
      hoursValue: "Mon – Fri: 9:00 – 18:00",
      weekend: "Saturday & Sunday: closed",
    },
    footer: { tagline: "The art of decorative plaster — cornices, rosettes, columns and bespoke decor.", rights: "All rights reserved.", nav: "Navigation", contact: "Contact", privacy: "Privacy", legal: "Legal notice" },
  },

  ru: {
    brand: "A&K Atelier",
    nav: { home: "Главная", about: "Мастерская", services: "Услуги", products: "Каталог", portfolio: "Работы", contact: "Контакты" },
    hero: {
      badge: "Мастер-создатель декора из гипса",
      title: "Искусство гипса в совершенстве",
      subtitle:
        "Карнизы, розетки, колонны и декор на заказ. Мы преображаем каждое пространство с элегантностью, традиционным мастерством и современным дизайном.",
      cta1: "Заказать расчёт",
      cta2: "Смотреть работы",
    },
    about: {
      badge: "Наша мастерская",
      title: "Мастерство на службе благородства",
      founded: "Мастерская основана в 2006 году",
      p1: "A&K Atelier объединяет традиционное мастерство и современный дизайн. Мы создаём изделия из натурального гипса, которые придают элегантность, характер и благородство любому интерьеру.",
      p2: "От классических элементов до современных декоративных панелей — мы предлагаем безграничные возможности для оформления интерьера, на заказ: от первого эскиза до монтажа.",
      stats: { projects: "Выполненных проектов", clients: "Довольных клиентов", experience: "Лет опыта", custom: "На заказ" },
    },
    services: {
      badge: "Что мы создаём",
      title: "Наши услуги",
      subtitle: "Полный спектр декора из натурального гипса ручной работы.",
      items: {
        corniches: { title: "Карнизы", desc: "Гладкие и резные карнизы, изящно оформляющие потолок." },
        rosaces: { title: "Розетки", desc: "Классические и современные потолочные розетки — акцент интерьера." },
        colonnes: { title: "Колонны и пилястры", desc: "Колонны и пилястры, придающие пространству величие." },
        moulures: { title: "Молдинги и фризы", desc: "Молдинги, фризы и тяги для элегантных переходов." },
        panneaux: { title: "Декоративные панели", desc: "Стеновые панели и рамки, преображающие любую поверхность." },
        decor: { title: "Декор на заказ", desc: "Уникальные изделия из гипса под ваш проект." },
        restauration: { title: "Реставрация", desc: "Реставрация фасадных и внутренних элементов старой гипсовой лепнины." },
      },
    },
    process: {
      badge: "Наш подход",
      title: "Как мы работаем",
      steps: {
        a: { title: "Консультация и расчёт", desc: "Обсуждаем ваш проект и составляем бесплатную смету." },
        b: { title: "Эскизы и подбор", desc: "Рисуем эскизы и подбираем подходящие профили." },
        c: { title: "Ручное изготовление", desc: "Каждое изделие отливается и дорабатывается вручную из натурального гипса." },
        d: { title: "Монтаж и отделка", desc: "Аккуратный монтаж и безупречная финишная отделка на объекте." },
      },
    },
    portfolio: {
      badge: "Наши работы",
      title: "Галерея наших работ",
      subtitle: "Реальные проекты — фотографии и видео с наших объектов.",
      photos: "Фото",
      videos: "Видео",
      view: "Увеличить",
      share: "Поделиться",
      shareCopy: "Скопировать ссылку",
      shareCopied: "Ссылка скопирована!",
      cats: { all: "Все", corniches: "Карнизы", moulures: "Молдинги", colonnes: "Колонны", interieurs: "Интерьеры" },
    },
    why: {
      badge: "Почему мы",
      title: "Преимущества A&K Atelier",
      items: {
        a: { title: "Натуральный гипс", desc: "Благородные и безопасные материалы для долговечной отделки." },
        b: { title: "Ручная работа", desc: "Каждое изделие создаётся и дорабатывается вручную нашими мастерами." },
        c: { title: "На заказ", desc: "От эскиза до монтажа — мы подстраиваем каждую деталь под ваш интерьер." },
        d: { title: "Безупречная отделка", desc: "Скрупулёзное внимание к каждой детали." },
      },
    },
    testimonials: {
      badge: "Нам доверяют",
      title: "Отзывы наших клиентов",
      items: {
        a: { name: "Sophie L.", role: "Архитектор интерьера", text: "Работа исключительной тонкости. Карнизы преображают каждую комнату." },
        b: { name: "Marc D.", role: "Владелец", text: "Серьёзная и увлечённая мастерская. Безупречный монтаж и достойный результат." },
        c: { name: "Élodie R.", role: "Декоратор", text: "Великолепные розетки, полностью ручная работа. Очень рекомендую." },
      },
    },
    catalog: {
      badge: "Наш каталог",
      title: "Продукция и решения",
      subtitle: "Полный ассортимент декоративных элементов из гипса — по категориям.",
      all: "Все",
      search: "Поиск продукта…",
      quote: "Заказать расчёт",
      empty: "В этой категории пока нет продукции.",
      more: "Показать ещё",
      sort: "Сортировка",
      sortDefault: "Рекомендуемые",
      sortAz: "Название А→Я",
      sortZa: "Название Я→А",
      order: "Заказать в WhatsApp",
      details: "Подробнее",
      similar: "Смотрите также",
      badges: { hit: "Хит", new: "Новинка" },
      bestBadge: "Подборка",
      bestTitle: "Хиты продаж",
      bestSubtitle: "Изделия, которые чаще всего выбирают наши клиенты.",
      cats: {
        corniches: "Карнизы", rosaces: "Розетки и короба", moldings: "Молдинги и орнаменты",
        wallpaper: "Обои", skirtings: "Плинтусы", cladding: "Облицовка стен",
        panels3d: "3D-панели", lighting: "Освещение", technical: "Технические решения",
        colonnes: "Колонны и обустройство",
      },
    },
    favorites: {
      title: "Избранное",
      add: "Добавить в избранное",
      remove: "Убрать из избранного",
      added: "Добавлено в избранное",
      removed: "Убрано из избранного",
      empty: "Список избранного пуст. Добавляйте изделия кнопкой с сердцем ♥.",
      clear: "Очистить список",
      sendWa: "Отправить список в WhatsApp",
      waIntro: "Здравствуйте! Меня интересуют эти изделия:",
      qty: "Кол-во",
      unit: "шт.",
      size: "размеры",
      sizePlaceholder: "Размеры / примечание (напр. дл. 2,5 м)",
    },
    cookie: {
      text: "Мы используем файлы cookie для улучшения работы сайта и аналитики.",
      accept: "Принять", decline: "Отклонить", learn: "Подробнее",
    },
    legal: { privacyTitle: "Политика конфиденциальности", legalTitle: "Правовая информация", back: "Вернуться на сайт", updated: "Последнее обновление" },
    reviews: {
      badge: "Отзывы клиентов",
      title: "Они нам доверились",
      subtitle: "Читайте отзывы наших клиентов и делитесь своим опытом.",
      leave: "Оставить отзыв",
      empty: "Будьте первым, кто оставит отзыв.",
      form: {
        title: "Поделитесь отзывом",
        rating: "Ваша оценка",
        text: "Ваш отзыв",
        textPlaceholder: "Опишите ваш опыт работы с A&K Atelier…",
        photos: "Фото (до 5)",
        add: "Добавить фото",
        submit: "Опубликовать отзыв",
        sending: "Публикация…",
        success: "Спасибо! Ваш отзыв опубликован.",
        error: "Не удалось опубликовать. Попробуйте снова.",
        loginRequired: "Войдите, чтобы оставить отзыв.",
      },
    },
    auth: {
      signin: "Войти",
      account: "Мой аккаунт",
      logout: "Выйти",
      loginTitle: "Вход",
      registerTitle: "Регистрация",
      name: "Имя",
      email: "E-mail",
      password: "Пароль",
      doLogin: "Войти",
      doRegister: "Зарегистрироваться",
      google: "Продолжить с Google",
      or: "или",
      haveAccount: "Уже есть аккаунт? Войти",
      noAccount: "Нет аккаунта? Регистрация",
      welcome: "Здравствуйте",
    },
    faq: {
      badge: "Частые вопросы",
      title: "Возможно, вы спросите…",
      items: {
        a: { q: "Работаете ли вы на заказ?", a: "Да, каждый декор проектируется и изготавливается под ваш проект и размеры." },
        b: { q: "Какие материалы вы используете?", a: "Натуральный гипс высокого качества — безопасный, прочный и экологичный." },
        c: { q: "Делаете ли вы ремонтные работы?", a: "Да, как для новых объектов, так и для реставрации — интерьер и фасад." },
        d: { q: "Какие сроки?", a: "Зависит от проекта; точные сроки уточняем вместе с бесплатной сметой." },
      },
    },
    contact: {
      badge: "Расскажите о вашем проекте",
      title: "Заказать расчёт",
      subtitle: "Оставьте контакты — мы свяжемся с вами в ближайшее время.",
      name: "Ваше имя",
      phone: "Телефон",
      email: "E-mail",
      message: "Опишите ваш проект",
      submit: "Отправить заявку",
      sending: "Отправка…",
      success: "Спасибо! Ваша заявка отправлена.",
      error: "Произошла ошибка. Повторите попытку или напишите нам в WhatsApp.",
      whatsapp: "Написать в WhatsApp",
      infoTitle: "Контакты",
      hoursLabel: "Режим работы",
      hoursValue: "Пн – Пт: 9:00 – 18:00",
      weekend: "Суббота и воскресенье: выходной",
    },
    footer: { tagline: "Искусство декоративной лепнины — карнизы, розетки, колонны и декор на заказ.", rights: "Все права защищены.", nav: "Навигация", contact: "Контакты", privacy: "Конфиденциальность", legal: "Правовая информация" },
  },

  uk: {
    brand: "A&K Atelier",
    nav: { home: "Головна", about: "Майстерня", services: "Послуги", products: "Каталог", portfolio: "Роботи", contact: "Контакти" },
    hero: {
      badge: "Майстер-творець декору з гіпсу",
      title: "Мистецтво гіпсу в досконалості",
      subtitle:
        "Карнизи, розетки, колони та декор на замовлення. Ми перетворюємо кожен простір з елегантністю, традиційною майстерністю та сучасним дизайном.",
      cta1: "Замовити розрахунок",
      cta2: "Переглянути роботи",
    },
    about: {
      badge: "Наша майстерня",
      title: "Майстерність на службі шляхетності",
      founded: "Майстерня заснована у 2006 році",
      p1: "A&K Atelier поєднує традиційну майстерність із сучасним дизайном. Ми створюємо вироби з натурального гіпсу, що надають елегантності, характеру та шляхетності будь-якому інтер'єру.",
      p2: "Від класичних елементів до сучасних декоративних панелей — ми пропонуємо безмежні можливості для оформлення інтер'єру на замовлення: від першого ескізу до монтажу.",
      stats: { projects: "Виконаних проєктів", clients: "Задоволених клієнтів", experience: "Років досвіду", custom: "На замовлення" },
    },
    services: {
      badge: "Що ми створюємо",
      title: "Наші послуги",
      subtitle: "Повний спектр декору з натурального гіпсу ручної роботи.",
      items: {
        corniches: { title: "Карнизи", desc: "Гладкі та різьблені карнизи, що вишукано оздоблюють стелю." },
        rosaces: { title: "Розетки", desc: "Класичні та сучасні стельові розетки — акцент інтер'єру." },
        colonnes: { title: "Колони та пілястри", desc: "Колони та пілястри, що надають простору величі." },
        moulures: { title: "Молдинги та фризи", desc: "Молдинги, фризи та тяги для елегантних переходів." },
        panneaux: { title: "Декоративні панелі", desc: "Стінові панелі та рамки, що перетворюють будь-яку поверхню." },
        decor: { title: "Декор на замовлення", desc: "Унікальні вироби з гіпсу під ваш проєкт." },
        restauration: { title: "Реставрація", desc: "Реставрація фасадних та внутрішніх елементів старої гіпсової ліпнини." },
      },
    },
    process: {
      badge: "Наш підхід",
      title: "Як ми працюємо",
      steps: {
        a: { title: "Консультація та розрахунок", desc: "Обговорюємо ваш проєкт і складаємо безкоштовний кошторис." },
        b: { title: "Ескізи та добір", desc: "Малюємо ескізи та добираємо відповідні профілі." },
        c: { title: "Ручне виготовлення", desc: "Кожен виріб відливається та доопрацьовується вручну з натурального гіпсу." },
        d: { title: "Монтаж та оздоблення", desc: "Акуратний монтаж і бездоганне фінішне оздоблення на об'єкті." },
      },
    },
    portfolio: {
      badge: "Наші роботи",
      title: "Галерея наших робіт",
      subtitle: "Реальні проєкти — фотографії та відео з наших об'єктів.",
      photos: "Фото",
      videos: "Відео",
      view: "Збільшити",
      share: "Поділитися",
      shareCopy: "Скопіювати посилання",
      shareCopied: "Посилання скопійовано!",
      cats: { all: "Усі", corniches: "Карнизи", moulures: "Молдинги", colonnes: "Колони", interieurs: "Інтер'єри" },
    },
    why: {
      badge: "Чому ми",
      title: "Переваги A&K Atelier",
      items: {
        a: { title: "Натуральний гіпс", desc: "Шляхетні та безпечні матеріали для довговічного оздоблення." },
        b: { title: "Ручна робота", desc: "Кожен виріб створюється та доопрацьовується вручну нашими майстрами." },
        c: { title: "На замовлення", desc: "Від ескізу до монтажу — ми підлаштовуємо кожну деталь під ваш інтер'єр." },
        d: { title: "Бездоганне оздоблення", desc: "Прискіплива увага до кожної деталі." },
      },
    },
    testimonials: {
      badge: "Нам довіряють",
      title: "Відгуки наших клієнтів",
      items: {
        a: { name: "Sophie L.", role: "Архітектор інтер'єру", text: "Робота виняткової витонченості. Карнизи перетворюють кожну кімнату." },
        b: { name: "Marc D.", role: "Власник", text: "Серйозна та захоплена майстерня. Бездоганний монтаж і гідний результат." },
        c: { name: "Élodie R.", role: "Декоратор", text: "Чудові розетки, повністю ручна робота. Дуже рекомендую." },
      },
    },
    catalog: {
      badge: "Наш каталог",
      title: "Продукція та рішення",
      subtitle: "Повний асортимент декоративних елементів з гіпсу — за категоріями.",
      all: "Усі",
      search: "Пошук продукту…",
      quote: "Замовити розрахунок",
      empty: "У цій категорії поки немає продукції.",
      more: "Показати ще",
      sort: "Сортування",
      sortDefault: "Рекомендовані",
      sortAz: "Назва А→Я",
      sortZa: "Назва Я→А",
      order: "Замовити у WhatsApp",
      details: "Деталі",
      similar: "Дивіться також",
      badges: { hit: "Хіт", new: "Новинка" },
      bestBadge: "Добірка",
      bestTitle: "Хіти продажів",
      bestSubtitle: "Вироби, які найчастіше обирають наші клієнти.",
      cats: {
        corniches: "Карнизи", rosaces: "Розетки та короби", moldings: "Молдинги та орнаменти",
        wallpaper: "Шпалери", skirtings: "Плінтуси", cladding: "Облицювання стін",
        panels3d: "3D-панелі", lighting: "Освітлення", technical: "Технічні рішення",
        colonnes: "Колони та облаштування",
      },
    },
    favorites: {
      title: "Обране",
      add: "Додати в обране",
      remove: "Прибрати з обраного",
      added: "Додано в обране",
      removed: "Прибрано з обраного",
      empty: "Список обраного порожній. Додавайте вироби кнопкою із серцем ♥.",
      clear: "Очистити список",
      sendWa: "Надіслати список у WhatsApp",
      waIntro: "Вітаю! Мене цікавлять ці вироби:",
      qty: "К-сть",
      unit: "шт.",
      size: "розміри",
      sizePlaceholder: "Розміри / примітка (напр. дов. 2,5 м)",
    },
    cookie: {
      text: "Ми використовуємо файли cookie для покращення роботи сайту та аналітики.",
      accept: "Прийняти", decline: "Відхилити", learn: "Докладніше",
    },
    legal: { privacyTitle: "Політика конфіденційності", legalTitle: "Правова інформація", back: "Повернутися на сайт", updated: "Останнє оновлення" },
    reviews: {
      badge: "Відгуки клієнтів",
      title: "Вони нам довірились",
      subtitle: "Читайте відгуки наших клієнтів і діліться своїм досвідом.",
      leave: "Залишити відгук",
      empty: "Будьте першим, хто залишить відгук.",
      form: {
        title: "Поділіться відгуком",
        rating: "Ваша оцінка",
        text: "Ваш відгук",
        textPlaceholder: "Опишіть ваш досвід роботи з A&K Atelier…",
        photos: "Фото (до 5)",
        add: "Додати фото",
        submit: "Опублікувати відгук",
        sending: "Публікація…",
        success: "Дякуємо! Ваш відгук опубліковано.",
        error: "Не вдалося опублікувати. Спробуйте ще раз.",
        loginRequired: "Увійдіть, щоб залишити відгук.",
      },
    },
    auth: {
      signin: "Увійти",
      account: "Мій акаунт",
      logout: "Вийти",
      loginTitle: "Вхід",
      registerTitle: "Реєстрація",
      name: "Ім'я",
      email: "E-mail",
      password: "Пароль",
      doLogin: "Увійти",
      doRegister: "Зареєструватися",
      google: "Продовжити з Google",
      or: "або",
      haveAccount: "Вже є акаунт? Увійти",
      noAccount: "Немає акаунту? Реєстрація",
      welcome: "Вітаємо",
    },
    faq: {
      badge: "Часті запитання",
      title: "Можливо, ви запитаєте…",
      items: {
        a: { q: "Чи працюєте ви на замовлення?", a: "Так, кожен декор проєктується та виготовляється під ваш проєкт і розміри." },
        b: { q: "Які матеріали ви використовуєте?", a: "Натуральний гіпс високої якості — безпечний, міцний та екологічний." },
        c: { q: "Чи виконуєте ремонтні роботи?", a: "Так, як для нових об'єктів, так і для реставрації — інтер'єр і фасад." },
        d: { q: "Які терміни?", a: "Залежить від проєкту; точні терміни уточнюємо разом із безкоштовним кошторисом." },
      },
    },
    contact: {
      badge: "Розкажіть про ваш проєкт",
      title: "Замовити розрахунок",
      subtitle: "Залиште контакти — ми зв'яжемося з вами найближчим часом.",
      name: "Ваше ім'я",
      phone: "Телефон",
      email: "E-mail",
      message: "Опишіть ваш проєкт",
      submit: "Надіслати заявку",
      sending: "Надсилання…",
      success: "Дякуємо! Вашу заявку надіслано.",
      error: "Сталася помилка. Спробуйте ще раз або напишіть нам у WhatsApp.",
      whatsapp: "Написати у WhatsApp",
      infoTitle: "Контакти",
      hoursLabel: "Режим роботи",
      hoursValue: "Пн – Пт: 9:00 – 18:00",
      weekend: "Субота та неділя: вихідний",
    },
    footer: { tagline: "Мистецтво декоративної ліпнини — карнизи, розетки, колони та декор на замовлення.", rights: "Усі права захищено.", nav: "Навігація", contact: "Контакти", privacy: "Конфіденційність", legal: "Правова інформація" },
  },
};

export const CONTACT = {
  phoneDisplay: "+33 7 53 64 65 96",
  phoneTel: "+33753646596",
  whatsapp: "33753646596",
  email: "ak.atelier06@gmail.com",
};
